<ng-container *transloco="let t; read: 'confirm-with-input'">
  <p [innerHTML]="data?.body"></p>

  <form *ngIf="!loading" [formGroup]="form">
    {{ t('confirmStr', { value: data.requiredConfirmationString }) }}
    <div class="form-row">
      <div class="col">
        <mat-form-field class="full-width">
          <input
            class="full-width"
            formControlName="confirmationString"
            matInput
            [attr.aria-label]="data.requiredConfirmationString"
            placeholder="{{ data.requiredConfirmationString }}"
          />
          <div *ngIf="confirmationString.invalid && confirmationString.dirty">
            <mat-error *ngIf="confirmationString.errors?.required">
              {{ t('errorRequired') }}
            </mat-error>
            <mat-error *ngIf="confirmationString.errors?.equals">
              {{ t('errorNotEqual', { value: data.requiredConfirmationString }) }}
            </mat-error>
          </div>
        </mat-form-field>
      </div>
    </div>
  </form>

  <button color="warn" mat-button type="button" [disabled]="!form.valid" (click)="confirm()">
    {{ t('confirmButton') }}
  </button>
  <button color="primary" mat-button type="button" (click)="cancel()">{{ t('cancelButton') }}</button>
</ng-container>
